<template>
	<div class="mainDiv">
		<div class="sideByDiv" style="height:100%;">
			<div class="inputSection">
				<Input placeholder="Latitude" :inputValue.sync="data.lat" :isRequired="true" textType="number" :isDisabled="viewMode" />
				<Input placeholder="Longitude" :inputValue.sync="data.lng" :isRequired="true" textType="number" :isDisabled="viewMode" />
				<Input placeholder="Height" :inputValue.sync="data.height" textType="number" :isDisabled="viewMode" />
				<div class="sideByDiv" :style="{display: (isGeofence ? 'flex':'none')}">
					<CheckBox class="customFont" :isChecked.sync="showGeofence" title="Geofence" :isDisabled="viewMode" />
					<button v-on:click="resetGeofence" class="customFont" :disabled="viewMode">Reset Geofence</button>
				</div>
				<div class="addressSection">
						<span style="font-size:15px; font-weight:bold;">Address Summary</span>
						<div class="addressContent">
							<div class="addrUpper"> 
								<div class="addrLines">
									<div class="content" style="font-weight: bold">{{ data['company'] || '--' }}</div>
									<div class="content">{{ data['addressLine1'] || '--' }}</div>
									<div class="content">{{ data['addressLine2'] || '--' }}</div>
									<div class="content">{{ data['addressLine3'] || '--' }}</div>
									<div class="content">{{ data['addressLine4'] || '--' }}</div>
									<div class="content">{{ data['postcodeSearch'] || '--' }}, {{ data['city'] || '--' }}</div>
									<div class="content">{{ data['stateSearch'] || '--' }}, {{ data['countrySearch'] || '--' }}</div>
								</div>
								<button class="showBtn" @click="refreshMap" :disabled="viewMode">Show your address on map</button>
							</div>
						</div>
				</div>
			</div>
			<div class="mapSection">
				<div class="gaddr" style="background-color: #1E90FF; color: white; " v-if="alertMsg && !viewMode">{{ alertMsg }}</div>
				<GoogleMap :marker_list="markerList" @moveMarker="moveMarker" @dragend="markerDragend" @newAddr="updateAddressSection" @alert="alertUser" :fitBounds="latlngbounds" :polygon="data.geofence" @polyPathUpdate="updateGeofence" :address="address" ref="gmap"/>
				<div id="gaddr" class="gaddr" v-if="address">{{ address }}</div>
				<!-- <RemarksBox class="gaddr" :text="addrData.fullAddr" :isDisabled="true" title="Full Address" freeText="true" />	 -->
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import GoogleMap from '@/components/GoogleMap.vue'; 
import CheckBox from '@/components/CheckBox.vue';

export default {
	components: {
		Input, GoogleMap, CheckBox,
	},
	data: function() {
		return {
			address: "",
			testaddress: "",
			addrData: {},
			alertMsg: "",
			markerList: [],
			latlngbounds: {}
		};
		
	},
	props: {
		viewMode: { type: Boolean, default: false }, //viewMode to disable inputs
		data: { type: Object, default: function () { return {} } },
		showGeofence: { type: Boolean, default: false },
		lat: { type: Number, default: 0 },
		lng: { type: Number, default: 0 },

		// Public
		isGeofence: { type: Boolean, default: false }, // show/hide geofence, put false if no geofence is needed
	},
	methods: {
		//Marker Methods
		updateMarker: function () {
			var marker = [{ position: { lat: parseFloat(this.data.lat || 0), lng: parseFloat(this.data.lng || 0) }, draggable: !this.viewMode }];
			this.markerList = [];
			this.markerList.push(marker);
			this.updateLatLngBound();
			//console.log(this.data.geofence);
		},
		async refreshMap(){
			this.updateMarker();
			this.alertMsg = "";
			document.getElementById("gaddr").innerText = ''
			this.address = this.data.address
			await this.$refs["gmap"].addrToCoords(this.data.address);
		},
		markerDragend: function (marker) {
			if(!marker) return
			this.alertMsg = "";
			this.data.lat = marker.latLng.lat().toString();
			this.data.lng = marker.latLng.lng().toString();
		},
		moveMarker(position){
			if(!position)
			this.data.lat = position.lat
			this.data.lng = position.lng
		},
		//Marker Methods
		//Geofence methods
		updateGeofence: function (e) {
			this.data.geofence[0].Path = [];
			e.forEach((g) => { this.data.geofence[0].Path.push(g); });
			this.updateLatLngBound();
		},
		resetGeofence: function () {
			if (this.showGeofence == true) {
				var markerLat = parseFloat(this.data.lat);
				var markerLng = parseFloat(this.data.lng);
				this.data.geofence = [{
					Path: [
						{ lat: markerLat + 0.0005, lng: markerLng - 0.0005 },
						{ lat: markerLat + 0.0005, lng: markerLng + 0.0005 },
						{ lat: markerLat - 0.0005, lng: markerLng + 0.0005 },
						{ lat: markerLat - 0.0005, lng: markerLng - 0.0005 },
					],
					Edit: true
				}];
			}
		},
		//Geofence methods
		updateLatLngBound: function () {
			try {
				this.latlngbounds = [];
				this.latlngbounds.push(this.markerList[0][0].position);
				if (this.data.geofence != undefined) {
          this.data.geofence[0].Path.forEach((g) => { this.latlngbounds.push(g); });
        }
			}
			catch (e) {
				//console.log(e);
			}
			//console.log(this.latlngbounds);
		},
		updateAddressSection(address){
			if(!address) return
			this.address = address.fullAddr || ''

			// When first mounted the html wont be updated so I use vanilla js instead to rewrite the value.
			document.getElementById("gaddr").innerText = address.fullAddr
		},
		alertUser(message){
			this.alertMsg = '[INFO] ' + message
		}
	},
	mounted() {

		if (this.data.geofence && this.data.geofence.length != 0) {
			this.showGeofence = true;
		}
	
		this.address = this.data.address

		// this.addrData = {
		// 		addressLine1: this.data.addressLine1 || '',
		// 		addressLine2: this.data.addressLine2 || '',
		// 		addressLine3: this.data.addressLine3 || '',
		// 		addressLine4: this.data.addressLine4 || '' ,
		// 		postcodeSearch: this.data.postcodeSearch || '',
		// 		city: this.data.city || '',
		// 		stateSearch: this.data.stateSearch || '', 
		// 		countrySearch: this.data.countrySearch || '', 
		// }

		// let fullAddr = ''
		// for(let key in this.addrData){
		// 	this.addrData[key] = this.addrData[key].replace(",", "")
		// 	fullAddr += (", " + this.addrData[key])
		// }
		// this.addrData.fullAddr = fullAddr.slice(2)
		// this.addrData.fullAddr = ''


	},
	watch: {
		data: {
			deep: true,
			handler(val) {
				this.updateMarker();
				// console.log(val);
			}
		},
		showGeofence: function () {
			if (this.showGeofence == 0) {
				this.data.geofence = [];
			}
			else {
				if (this.data.geofence.length == 0) {
					this.resetGeofence();
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>

.mainDiv {
	height: 400px;
	padding-top: 10px;
	padding-bottom: 10px;
	display: flex;
	flex-direction: column;
}

.sideByDiv {
	display: flex;
	justify-content: space-between;
}

.customFont {
	font-size: 12px;
}

.inputSection {
	padding-right: 5px;
}

.mapSection {
	padding-left: 5px;
	height: 85%;
}

.mapSection, .inputSection {
	// height: 100%;
	width: 50%;
}

.addressSection {
	 width: 100%; 
	 
	> .addressContent{
		background-color:white;
	 	border: 1px black solid;
		border-radius: 5px;
		max-height: 100%;
		display:flex;
		flex-direction: column;
		padding: 5px;

		> .addrBtn {
			display: flex;
			margin-top: 10px;
			margin: 0 10px 5px 0;
			max-width: fit-content;
			align-self: flex-end;
		}
	}
}

.gaddr {
	width: 100%;
	overflow-y: hidden;
	background-color: lightgreen;
	padding: 5px 5px;
}

.addrUpper {
	display: flex;
	justify-content: space-between;
		
	> .addrLine {
		display: flex;
		flex-direction: column;
		padding: 5px 0px;
		width: 70%
	}

	> .showBtn {
		max-height: 30px;
	}
}

.addrRest {
	display: flex;
	flex-direction: row;
	margin-top: 15px;
	width: 100%;
	flex-grow: 1;
}

.title {
	margin-top: 5px;
	padding: 0px 10px;
	width: fit-content;
	font-weight: bold;
}
</style>
